package ext

import common.dto.Vec3d
import three.js.Euler
import three.js.Vector3
import kotlin.math.roundToInt

fun Vec3d.asVector3() = Vector3(x, y, z)
fun Vector3.asVec3d() = Vec3d(x.toDouble(), y.toDouble(), z.toDouble())

fun Vector3.set(vec3d: Vec3d) = apply {
    set(vec3d.x, vec3d.y, vec3d.z)
}

fun Vector3.set(vector3: Vector3) = apply {
    set(vector3.x, vector3.y, vector3.z)
}

fun Vec3d.asEuler() = Euler(x, y, z)
fun Euler.asVec3d() = Vec3d(x.toDouble(), y.toDouble(), z.toDouble())

fun Euler.set(vec3d: Vec3d): Euler = apply {
    set(vec3d.x, vec3d.y, vec3d.z)
}

// Operators
operator fun Vec3d.plus(vec3d: Vec3d) = Vec3d(x + vec3d.x, y + vec3d.y, z + vec3d.z)
operator fun Vec3d.minus(vec3d: Vec3d) = Vec3d(x - vec3d.x, y - vec3d.y, z - vec3d.z)
operator fun Vec3d.times(scalar: Double) = Vec3d(x * scalar, y * scalar, z * scalar)
operator fun Vec3d.div(scalar: Double) = Vec3d(x / scalar, y / scalar, z / scalar)
operator fun Vec3d.unaryMinus() = Vec3d(-x, -y, -z)
infix fun Vec3d.dot(vec3d: Vec3d) = x * vec3d.x + y * vec3d.y + z * vec3d.z

/**
 * Round the three components to the nearest multiple of [stepSize].
 */
fun Vec3d.roundStepped(stepSize: Double) = Vec3d(
    (x / stepSize).roundToInt() * stepSize,
    (y / stepSize).roundToInt() * stepSize,
    (z / stepSize).roundToInt() * stepSize
)